import { range } from 'ramda';

/**
 * Create all possible pathname keys from pathname
 * @example /toolbox/invoices/documents -> ['/toolbox', '/toolbox/invoices', '/toolbox/invoices/documents']
 */
export const createPathnameKeys = (pathname: string) => {
  const pathSplit = pathname.split('/');
  return range(1, pathSplit.length + 1).reduce<Array<string>>((acc, index) => {
    const path = pathSplit.slice(0, index).join('/');
    acc.push(path);
    return acc;
  }, []);
};
